// Package Imports
import { ROUTES } from '@/core/constants/routes'
import { useNavigate } from '@tanstack/react-router'
import { Button } from 'antd'
import { motion } from 'motion/react'
import { FiArrowLeft, FiCompass, FiHome } from 'react-icons/fi'

const GlobalNotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-linear-to-br from-indigo-50 via-sky-50 to-violet-50 px-4 py-10">
      <div className="pointer-events-none absolute -top-32 -left-24 h-80 w-80 rounded-full bg-indigo-200/50 blur-3xl" />
      <div className="pointer-events-none absolute -right-24 -bottom-32 h-96 w-96 rounded-full bg-violet-200/50 blur-3xl" />

      <motion.div
        initial={{ opacity: 0, y: 24, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.45, ease: 'easeOut' }}
        className="relative w-full max-w-md rounded-3xl border border-white/60 bg-white/85 px-8 pt-10 pb-9 text-center shadow-[0_20px_60px_-15px_rgba(129,140,248,0.35)] backdrop-blur"
      >
        <motion.div
          initial={{ rotate: 0, scale: 0.85 }}
          animate={{ rotate: 360, scale: 1 }}
          transition={{
            rotate: { duration: 12, repeat: Infinity, ease: 'linear' },
            scale: { duration: 0.6, ease: 'easeOut' },
          }}
          className="mx-auto mb-3 flex h-24 w-24 items-center justify-center rounded-full bg-linear-to-br from-indigo-500 to-violet-500 text-white shadow-lg shadow-indigo-200"
          data-testid="global-not-found-icon"
        >
          <FiCompass className="text-5xl" />
        </motion.div>

        <div className="mb-2 bg-linear-to-br from-indigo-500 to-violet-500 bg-clip-text text-7xl leading-none font-black text-transparent">
          404
        </div>

        <h1 className="m-0 mb-2 text-2xl font-bold text-gray-900">
          Sayfa Bulunamadı
        </h1>
        <p className="m-0 mb-7 text-sm leading-relaxed text-gray-600">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir. Doğru yola
          dönmek için aşağıdaki seçeneklerden birini kullanın.
        </p>

        <div className="flex flex-col gap-2.5 sm:flex-row sm:justify-center">
          <Button
            type="primary"
            size="large"
            icon={<FiHome />}
            className="rounded-full! font-medium!"
            onClick={() => navigate({ to: ROUTES.dashboard })}
          >
            Yönetime Dön
          </Button>
          <Button
            size="large"
            icon={<FiArrowLeft />}
            className="rounded-full! font-medium!"
            onClick={() => globalThis.history.back()}
          >
            Geri Dön
          </Button>
        </div>
      </motion.div>
    </div>
  )
}

export default GlobalNotFound
